import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import RouterOutlinedIcon from "@mui/icons-material/RouterOutlined";
import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";

// Catálogo visual dos tipos de host (usado em cadastroHosts/VincularClientesStep
// e no combobox de host do diagrama de equipamentos do circuito)
export const HOST_TYPES = [
  {
    value: "cpe",
    label: "Host",
    icon: <StorageOutlinedIcon fontSize="small" />,
    color: "primary",
    description: "Switch, roteador, firewall ou equipamento CPE do cliente",
  },
  {
    value: "onu",
    label: "ONU",
    icon: <RouterOutlinedIcon fontSize="small" />,
    color: "success",
    description: "Optical Network Unit (ONU/ONT) de fibra óptica",
  },
  {
    value: "link",
    label: "Link",
    icon: <SettingsEthernetIcon fontSize="small" />,
    color: "warning",
    description: "Interface de link dedicado",
  },
  {
    value: "session",
    label: "Sessão",
    icon: <ShareOutlinedIcon fontSize="small" />,
    color: "error",
    description: "Host configurado em uma sessão (BGP, VRF, etc.)",
  },
];

export const getHostTypeConfig = (value) =>
  HOST_TYPES.find((tipo) => tipo?.value === value);

// Balde do payload de /interno/findMany/hostsCliente (mapHostsByServiceAndEquipmentType)
// -> value do catálogo HOST_TYPES
const HOST_BUCKET_TO_TYPE = {
  cpes: "cpe",
  onus: "onu",
  links: "link",
  sessions: "session",
};

// Reagrupa os 4 baldes (cpes/onus/links/sessions) da resposta de
// /interno/findMany/hostsCliente num único mapa por serviço, marcando a categoria
// de cada host. Concatena por categoria de forma contígua (cpe -> onu -> link ->
// session dentro de cada serviço), exigido pelo groupBy do MUI Autocomplete
export const flattenHostsByService = (hostsCliente = {}) => {
  const resultado = {};
  Object.entries(HOST_BUCKET_TO_TYPE).forEach(([balde, category]) => {
    const porServico = hostsCliente?.[balde] || {};
    Object.entries(porServico).forEach(([servicoId, hosts]) => {
      const hostsComCategoria = (hosts || []).map((host) => ({ ...host, category }));
      resultado[servicoId] = [...(resultado[servicoId] || []), ...hostsComCategoria];
    });
  });
  return resultado;
};
